import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Avatar } from "orcs-design-system";

import { getGroupBgImg } from "src/util/group";
import { getTeamGradient, AvatarWithGradient } from "src/util/gradient";
import useGetBranding from "src/hooks/useGetBranding";

const TeamAvatar = ({ group, ...props }) => {
  const branding = useGetBranding();

  const image = useMemo(() => {
    return getGroupBgImg(group);
  }, [group]);

  const bgGradient = useMemo(() => {
    return !image && getTeamGradient(branding, group);
  }, [image, branding, group]);

  const AvatarComponent = useMemo(() => {
    return image ? Avatar : AvatarWithGradient;
  }, [image]);

  return (
    <AvatarComponent
      shape="square"
      image={image}
      imageAlt={`Avatar of ${group.name}`}
      bgGradient={bgGradient}
      {...props}
    />
  );
};

TeamAvatar.propTypes = {
  group: PropTypes.object,
};

export default TeamAvatar;
